module.exports = __webpack_public_path__ + "static/media/beauty1.38bec4c0.png";